import {
    Box,
    Flex,
    Text,
    Image,
    Divider,
    Grid,
    Table,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    Spinner,
} from '@chakra-ui/react';
import MyDiv from './oldInvestmentTaxRegime.style';
import CheckMarkIcon from '../../../../assets/images/CheckMarkIcon.svg';
import SalaryIcon from "../../../../assets/images/SalaryIcon.svg";
import { AlertCard, CustomButton } from '../../../../components';

const OldInvestmentTaxRegime = ({
    isLoading,
    setIsLoading,
    showAcceptedDetails,
    showRejectedDetails,
    alertOpen,
    alertStatus,
    setAlertOpen,
    setAlertStatus,
    onConfirmStatusChange
}: any)  => {
   
    const taxDeclarations = [
        { label: 'Standard Deduction', value: '₹ 123456' },
        { label: 'House Rent Allowance (HRA)', value: '₹  12345' },
        { label: 'Leave Travel Allowance (LTA)', value: '₹  12345' },
        { label: 'Section 80C Deductions (E.G., PF, ELSS, PPF)', value: '₹  12345' },
        { label: 'Section 80D (Medical Insurance)', value: '₹  12345' },
        { label: 'Section 80E (Education Loan Interest)', value: '₹  12345' },
        { label: 'Other Applicable Deductions (Section 80G, 801TA, Etc.)', value: '₹  12345' },
        { label: 'Total Deduction Claimed', value: '₹ 123456' }
    ];

    const sections = [
        {
            title: 'Salary & Experience Details',
            icon: SalaryIcon,
            data: [
                { label: 'Experienced', value: '2 Years' },
                { label: 'Gross Salary Per Annum', value: '₹ 12345' },
                { label: 'Deductions', isHeading: true },
                { label: 'PF', value: '₹ 12345' },
                { label: 'Professional Tax', value: '₹ 12345' },
                { label: 'TDS', value: '₹ 12345' },
                { label: 'Total Deduction', value: '₹ 12345' },
                { label: 'Net Salary', value: '₹ 12345' },
            ],
        },
    ];

    // Data for the accepted view
    const salaryDetails = {
        grossSalary: '₹ 12345',
        icon: SalaryIcon,
        deductions: [
            { name: 'PF', before: '₹ 12345', after: '₹ 12345' },
            { name: 'Professional Tax', before: '₹ 12345', after: '₹ 12345' },
            { name: 'TDS', before: '₹ 12345', after: '₹ 12345' },
            { name: 'Total Deductions', before: '₹ 12345', after: '₹ 12345' },
            { name: 'Net Salary', before: '₹ 12345', after: '₹ 12345' },
        ],
        acceptedBy: 'HR Name',
        acceptedDate: new Date().toLocaleDateString(),
        acceptedTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    };

    const handleAcceptClick = () => {
        setAlertStatus('Accept');
        setAlertOpen(true);
    };

    const handleRejectClick = () => {
        setAlertStatus('Reject');
        setAlertOpen(true);
    };

    return (
        <MyDiv>
            <Flex gap={2} mb={4} mt={4}>
                <Box className='declaration'>
                    <Image src={CheckMarkIcon} />
                    <Text className="font-poppins text_sm text_medium">Tax Declaration</Text>
                </Box>
                <Box>
                    <Box className='regime'>
                        <Flex gap={4} alignItems={'center'}>
                            <Text color={'#0000FF'} className="font-poppins text_sm text_medium">Tax Regime</Text>
                            <Text className='old font-poppins text_sm text_medium' >Old Tax Regime</Text>
                        </Flex>
                    </Box>
                </Box>
            </Flex>
            {!showAcceptedDetails && !showRejectedDetails ? (
                <>
                    {sections.map((section, index) => (
                        <Box key={index} pt={2} mb={6} className="main">
                            <Flex justify="space-between" align="center" mb={2} pl={5} pr={5}>
                                <Flex align="center" gap={3}>
                                    <Image src={section.icon} alt={section.title} />
                                    <Text className="font-poppins text_sm text_medium col">{section.title}</Text>
                                </Flex>
                            </Flex>
                            {section.data.map((item, i) => (item.isHeading ? (
                                <Text className="font-poppins text_sm text_medium col" key={i} px={10} py={2}>{item.label}</Text>) : (
                                <Box key={i} py={2} px={10} bg="#FFFFFF" borderRadius={8}>
                                    <Grid templateColumns="1fr 1fr" alignItems="center">
                                        <Text className="font-poppins text_sm text_medium" color="rgba(102, 102, 102, 1)" mb={3}>{item.label}</Text>
                                        <Text className="font-poppins text_sm text_medium col" ml={8}>{item.value}</Text>
                                    </Grid>
                                    {!section.data[i + 1]?.isHeading && i !== section.data.length - 1 && <Divider mt={2} />}
                                </Box>
                            )))}
                        </Box>
                    ))}

                    <Text className='font-poppins text_xl text_semibold'>Tax Declarations Details</Text>
                    <Box className="section-card" mt={2} p={6}>
                        <Flex flexDirection="column">
                            {taxDeclarations.map((item, index) => (
                                <Box key={index}>
                                    <Flex justify="space-between">
                                        <Text className="font-poppins text_sm text_medium" color="rgba(102, 102, 102, 1)">{item.label}</Text>
                                        <Text className="font-poppins text_sm text_medium col">{item.value}</Text>
                                    </Flex>
                                    {index !== taxDeclarations.length - 1 && <Divider borderColor="#EAECF0" mt={8} />}
                                </Box>
                            ))}
                        </Flex>
                    </Box>
                    <Box className="section-box mt-6">
                        <Flex justify="flex-end" gap={4} mt={6}>
                            <CustomButton
                                title="Reject"
                                className='reject font-poppins text_sm text_medium'
                                onClick={handleRejectClick}
                            />
                            <CustomButton
                                title="Accept"
                                className='accept font-poppins text_sm text_medium'
                                onClick={handleAcceptClick}
                            />
                        </Flex>
                    </Box>
                </>
            ) : showAcceptedDetails ? (
                <>
                    <Box className="accepted-view" mt={6}>
                        <Box className='head' pt={2} pb={2}>
                            <Flex justify="space-between" align="center" pl={3}>
                                <Flex align="center" gap={2}>
                                    <Image src={salaryDetails.icon} alt="Img" />
                                    <Text className="font-poppins text_xl text_semibold">Salary & Experience Details</Text>
                                </Flex>
                            </Flex>
                        </Box>
                        <Flex align="center">
                            <Text className="font-poppins text_md text_medium" mb={6} mt={6} pl={12}>Gross Salary Per Annum</Text>
                            <Text className="font-poppins text_sm text_medium"  pl={24}>{salaryDetails.grossSalary}</Text>
                        </Flex>

                        <Table variant="simple" mb={8} className="deductions-table">
                            <Thead>
                                <Tr>
                                    <Th className="font-poppins text_sm text_medium font_dark">Deductions</Th>
                                    <Th className="font-poppins text_sm text_medium font_dark">Before</Th>
                                    <Th className="font-poppins text_sm text_medium font_dark">After</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {salaryDetails.deductions.map((deduction, index) => (
                                    <Tr key={index}>
                                        <Td className="font-poppins text_sm text_medium" color="rgba(102, 102, 102, 1)">{deduction.name}</Td>
                                        <Td className="font-poppins text_sm text_medium">{deduction.before}</Td>
                                        <Td className="font-poppins text_sm text_medium">{deduction.after}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Box>
                    <Text className="font-poppins text_xl text_semibold" mb={4} ml={4}>Tax Declarations Details</Text>
                    <Text className="font-poppins text_sm text_medium" ml={4} color='#68CA44'>
                        The tax declaration was reviewed and accepted by {salaryDetails.acceptedBy} on {salaryDetails.acceptedDate}, {salaryDetails.acceptedTime}.
                    </Text>
                </>
            ) : (
                <>
                    {sections.map((section, index) => (
                        <Box key={index} pt={2} mb={6} className="main">
                            <Flex justify="space-between" align="center" mb={2} pl={5} pr={5}>
                                <Flex align="center" gap={3}>
                                    <Image src={section.icon} alt={section.title} />
                                    <Text className="font-poppins text_sm text_medium col">{section.title}</Text>
                                </Flex>
                            </Flex>
                            {section.data.map((item, i) => (item.isHeading ? (
                                <Text className="font-poppins text_sm text_medium col" key={i} px={10} py={2}>{item.label}</Text>) : (
                                <Box key={i} py={2} px={10} bg="#FFFFFF" borderRadius={8}>
                                    <Grid templateColumns="1fr 1fr" alignItems="center">
                                        <Text className="font-poppins text_sm text_medium" color="rgba(102, 102, 102, 1)" mb={3}>{item.label}</Text>
                                        <Text className="font-poppins text_sm text_medium col" ml={8}>{item.value}</Text>
                                    </Grid>
                                    {!section.data[i + 1]?.isHeading && i !== section.data.length - 1 && <Divider mt={2} />}
                                </Box>
                            )))}
                        </Box>
                    ))}

                    <Text className="font-poppins text_xl text_semibold" mb={4} ml={4}>Tax Declarations Details</Text>
                    <Text className="font-poppins text_sm text_medium rejected-text" ml={4}>
                        The tax declaration was rejected by {salaryDetails.acceptedBy} on {salaryDetails.acceptedDate}, {salaryDetails.acceptedTime}.
                    </Text>
                </>
            )}

            <Modal isOpen={isLoading} onClose={() => setIsLoading(false)} isCentered>
                <ModalOverlay />
                <ModalContent
                    width="303px"
                    height="180px"
                    borderRadius="12px"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <ModalBody
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        gap="24px"
                        textAlign="center"
                    >
                        <Spinner
                            thickness='4px'
                            speed='0.65s'
                            emptyColor='gray.200'
                            color={alertStatus === 'Accept' ? 'blue.500' : 'red.500'}
                            size='xl'
                        />
                        <Text className='font-poppins text_sm text_medium' mt={2}>
                            {alertStatus === 'Accept' ? 'Calculating Taxable Income after deductions' : 'Processing Rejection request'}
                        </Text>
                    </ModalBody>
                </ModalContent>
            </Modal>

            <AlertCard
                isOpen={alertOpen}
                onClose={() => setAlertOpen(false)}
                onConfirm={onConfirmStatusChange}
                title={alertStatus === 'Accept' ? 'Approved' : 'Rejected'}
                description={`Are you sure you want to ${alertStatus?.toLowerCase()} this request?`}
                confirmLabel="Confirm"
                colorScheme={alertStatus === 'Accept' ? 'green' : 'red'}
            />
        </MyDiv>
    );
};

export default OldInvestmentTaxRegime;
